module.exports = __webpack_public_path__ + "static/media/1.27874859.jpg";